import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { RouterModule, provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import { APP_ROUTES } from './app.routes';
import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';

import { provideClientHydration, withEventReplay, withHttpTransferCacheOptions } from '@angular/platform-browser';
import { AppModule } from './app.module';
import {
  provideGlobalErrorHandler,
  providePostBootstrapVersionLogger,
  provideSwiperLoader
} from '@usheru-hff/shared/utils';
import { NgProgressRouterModule } from 'ngx-progressbar/router';
import { provideLazyToast } from '@usheru-hff/ui/notfication';
import { provideUshTheme } from '@usheru-hff/ui/theme';

import { currentGitVersion } from './version';

export const appConfig: ApplicationConfig = {
  providers: [
    provideSwiperLoader(),
    provideClientHydration(withEventReplay(), withHttpTransferCacheOptions({ includeRequestsWithAuthHeaders: true })),
    provideRouter(
      APP_ROUTES,
      withComponentInputBinding(),
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled'
      })
    ),
    importProvidersFrom(AppModule, NgProgressRouterModule),
    provideLazyToast(),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    providePostBootstrapVersionLogger(currentGitVersion),
    provideGlobalErrorHandler(true),
    provideUshTheme(),
    provideHttpClient(withFetch())
  ]
};
